import { cva } from 'class-variance-authority'
import PropTypes from 'prop-types'

import { ActionButtons } from '@/components/ActionButtons'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/elements/dialog'
import { cn } from '@/utils/helpers'

const modalVariants = cva('', {
  variants: {
    size: {
      sm: 'sm:max-w-[425px]',
      md: 'sm:max-w-xl',
      lg: 'sm:max-w-2xl',
      xl: 'sm:max-w-6xl',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

const Modal = ({
  actions = [],
  description = null,
  content,
  loading = false,
  open = true,
  setOpen,
  title,
  contentClasses = '',
  size = 'sm',
  ...rest
}) => (
  <Dialog open={open} onClose={() => setOpen(false)} {...rest}>
    <DialogContent
      className={cn(
        modalVariants({ size }),
        contentClasses,
        'max-h-[90vh] overflow-y-scroll overscroll-none',
      )}
      setOpen={setOpen}
    >
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>

      {content}
      {actions && actions.length > 0 && (
        <DialogFooter>
          <ActionButtons actions={actions} loading={loading} />
        </DialogFooter>
      )}
    </DialogContent>
  </Dialog>
)

Modal.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  content: PropTypes.node.isRequired,
  description: PropTypes.string,
  loading: PropTypes.bool,
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  contentClasses: PropTypes.string,
}

export default Modal
